var map = {
	"./about.jpg": 493,
	"./bbq-steak.jpg": 295,
	"./boewors.jpg": 903,
	"./chicken-mushroom.jpg": 578,
	"./chicken-tikka.jpg": 361,
	"./hawaiian.jpg": 203,
	"./home-frame-1-small.jpg": 327,
	"./home-frame-1.jpg": 429,
	"./peri-peri-chicken.jpg": 360,
	"./regina.jpg": 482,
	"./test.jpg": 755,
	"./veg-tikka.jpg": 962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;